import type { WorkBook } from 'xlsx-ugnis';

import { loadXlsx } from './load-xlsx';

export const mapWorkbook = async (
  workbook: WorkBook | null,
  sheetName?: string
) => {
  const XLSX = await loadXlsx();
  const worksheet =
    // @ts-expect-error noUncheckedIndexedAccess
    workbook?.Sheets[sheetName || workbook?.SheetNames[0]] || {};
  const data = XLSX.utils.sheet_to_json(worksheet, {
    header: 1,
    blankrows: false,
    raw: false,
  });
  return data as string[][];
};
